// src/Conversion/SqlFormat.js
import { format, supportedDialects } from "sql-formatter";

export const formatSql = (input, language = "sql") => {
    try {
        if (!supportedDialects.includes(language)) {
            return `Unsupported SQL dialect: ${language}`;
        }

        return format(input, {
            language, // 'sql', 'mysql', 'postgresql', etc.
            indent: "    ",
        });
    } catch (error) {
        return "Invalid SQL query";
    }
};

export const getSupportedDialects = () => supportedDialects;
